<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Skills
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs10>
            <v-select
            v-model="skill"
            :items="skillOptions"
            :menu-props="{ maxHeight: '400' }"
            label="Select"
            multiple
            prepend-icon="build"
            hint="skills"
            persistent-hint
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Competencies
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs10>
            <v-select
            v-model="competency"
            :items="competencyOptions"
            :menu-props="{ maxHeight: '400' }"
            label="Select"
            multiple
            prepend-icon="shield"
            hint="competencies"
            persistent-hint
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Certificates
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs10>
            <v-select
            v-model="certificate"
            :items="certificateOptions"
            :menu-props="{ maxHeight: '400' }"
            label="Select"
            multiple
            prepend-icon="receipt_long"
            hint="skills"
            persistent-hint
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Licences
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs10>
            <v-select
            v-model="licence"
            :items="licenceOptions"
            :menu-props="{ maxHeight: '400' }"
            label="Select"
            multiple
            prepend-icon="badge"
            hint="licenses"
            persistent-hint
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout wrap align-centre justify-center row fill-height class="mt-4">
          <!-- <RoleDevelopmentManageCard :data="{tag: 'H2', type: 'skill'}"/>
          <RoleDevelopmentManageCard :data="{tag: 'H3', type: 'comp'}"/>
          <RoleDevelopmentManageCard :data="{tag: 'H4', type: 'cert'}"/>
          <RoleDevelopmentManageCard :data="{tag: 'H5', type: 'licence'}"/> -->
        </v-layout>
        <v-layout wrap align-centre justify-center row fill-height class="mt-2">
          <!-- <RoleDevelopmentSummaryCard/> -->
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import peopleOptions from "@/data/options/mixins/peopleOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      localForm: {
        skill: "",
        competency: "",
        certificate: "",
        licence: ""
      },
      orgForm: {
        skill: "",
        competency: "",
        certificate: "",
        licence: ""
      },
      skill: "",
      competency: "",
      certificate: "",
      licence: ""
    };
  },
  watch: {
    skill() {
      this.localForm.skill = this.skill;
      this.updateFormRelps();
    },
    competency() {
      this.localForm.competency = this.competency;
      this.updateFormRelps();
    },
    certificate() {
      this.localForm.certificate = this.certificate;
      this.updateFormRelps();
    },
    licence() {
      this.localForm.licence = this.licence;
      this.updateFormRelps();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.skill = this.getDetailRelps.h1;
    this.competency = this.getDetailRelps.h2;
    this.certificate = this.getDetailRelps.h3;
    this.licence = this.getDetailRelps.h4;
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    peopleOptions
  ],
  computed: {
    ...mapGetters(["getDetailRelps"]),
    userStatus() {
      let status = null;
      if (this.getUserBasic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormRelps() {
      let relps = this.getDetailRelps;
      relps.h1 = this.skill;
      relps.h2 = this.competency;
      relps.h3 = this.certificate;
      relps.h4 = this.licence;
      this.$store.dispatch("changeDetailRelps", relps);
      // when loaded first time ctr is = 1 as s3 / s4 load
      if (this.ctr > 3) {
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      // This conter ensure that the Hazard Contrl does not fire
      //  in the first page show
      this.ctr = this.ctr + 1;
    }
  }
};
</script>
